import SectionTitle from "../common/SectionTitle";
import { MapPin, School2, Hospital, ShoppingBag } from "lucide-react";
import { motion } from "framer-motion";

const LocationSnapshot = () => {
  return (
    <section className="py-10 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Section Title */}
        <motion.div
          initial="hidden"
          whileInView="visible"
          viewport={{ once: true }}
          variants={{
            hidden: { opacity: 0, y: 40 },
            visible: { opacity: 1, y: 0, transition: { duration: 0.6 } }
          }}
        >
          <SectionTitle
            title="Location Snapshot"
            subtitle="Well-connected and close to all essential needs"
          />
        </motion.div>

        {/* Location Cards */}
        <div className="grid md:grid-cols-4 gap-6 mt-10">
          {[
            {
              icon: <MapPin className="w-6 h-6 text-emerald-600" />,
              title: "Connectivity",
              desc: "Easy access to highways & main roads"
            },
            {
              icon: <School2 className="w-6 h-6 text-emerald-600" />,
              title: "Schools",
              desc: "Top schools within 10–15 mins"
            },
            {
              icon: <Hospital className="w-6 h-6 text-emerald-600" />,
              title: "Hospitals",
              desc: "Reliable medical facilities nearby"
            },
            {
              icon: <ShoppingBag className="w-6 h-6 text-emerald-600" />,
              title: "Daily Needs",
              desc: "Markets & malls within close distance"
            }
          ].map((item, idx) => (
            <motion.div
              key={idx}
              className="bg-gradient-to-br from-emerald-50 to-teal-50 p-6 rounded-2xl border border-gray-200 shadow-sm"
              whileHover={{ y: -6, scale: 1.02 }}
              transition={{ type: "spring", stiffness: 200 }}
            >
              <div className="w-12 h-12 flex items-center justify-center rounded-lg bg-emerald-100 mb-4">
                {item.icon}
              </div>
              <h4 className="font-bold text-lg">{item.title}</h4>
              <p className="text-gray-600 text-sm mt-2">{item.desc}</p>
            </motion.div>
          ))}
        </div>

      </div>
    </section>
  );
};

export default LocationSnapshot;
